var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxDashboardOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4926 11.2925H14.8308C14.4399 11.2925 14.123 11.6093 14.123 12.0002V20.4929C14.123 20.8837 14.4399 21.2007 14.8308 21.2007H20.4926C20.8834 21.2007 21.2003 20.8837 21.2003 20.4929V12.0002C21.2003 11.6093 20.8834 11.2925 20.4926 11.2925Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4926 2.80005H14.8308C14.4399 2.80005 14.123 3.11691 14.123 3.50778V6.35284C14.123 6.7437 14.4399 7.06056 14.8308 7.06056H20.4926C20.8834 7.06056 21.2003 6.7437 21.2003 6.35284V3.50778C21.2003 3.11691 20.8834 2.80005 20.4926 2.80005Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17032 2.80005H3.50851C3.11764 2.80005 2.80078 3.11691 2.80078 3.50778V12.0005C2.80078 12.3914 3.11764 12.7082 3.50851 12.7082H9.17032C9.56118 12.7082 9.87805 12.3914 9.87805 12.0005V3.50778C9.87805 3.11691 9.56118 2.80005 9.17032 2.80005Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17032 16.9402H3.50851C3.11764 16.9402 2.80078 17.257 2.80078 17.6479V20.493C2.80078 20.8838 3.11764 21.2007 3.50851 21.2007H9.17032C9.56118 21.2007 9.87805 20.8838 9.87805 20.493V17.6479C9.87805 17.257 9.56118 16.9402 9.17032 16.9402Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxDashboardOutline);
export default __webpack_public_path__ + "static/media/icon_24px_dashboard_outline.2ebc66ae46b91adce0e46a0e4a022959.svg";
export { ForwardRef as ReactComponent };